// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__33mBN","title":"Images45_title__3YJEW","images":"Images45_images__3lHNb"};